import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    search: undefined,
    objectTypeId: undefined,
    eventTypeId: undefined,
    categoryId: undefined,
  },
  isOpenSidebar: false,
}

export const eventSlice = createAppSlice({
  name: 'event',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleSidebarEvent: create.reducer((state, { payload }) => {
      state.isOpenSidebar = !state.isOpenSidebar
    }),
  }),
  extraReducers: (builder) => {},
})

export const { setFetchOption, toggleSidebarEvent } = eventSlice.actions

export default eventSlice.reducer
